import type { ReactNode } from 'react';
import { YearHeaderRow, QuarterHeaderRow } from './QuarterHeader';
import { getForecastContext } from './periods';
import { useTableSettings } from './TableSettingsContext';

interface FinancialTableProps {
  children: ReactNode;
  labelWidth?: string;
}

export function FinancialTable({ children, labelWidth = 'w-64' }: FinancialTableProps) {
  const { settings } = useTableSettings();
  const ctx = settings ? getForecastContext(settings) : getForecastContext({ forecastStartYear: 2026, numForecastYears: 4 } as any);
  const historicalYears = settings?.historicalYears ?? [];

  return (
    <div className="flex-1 min-h-0 min-w-0 overflow-auto pb-8">
      <table className="border-collapse min-w-full">
        <thead className="sticky top-0 z-20">
          {ctx.periodType !== 'annual' && (
            <YearHeaderRow labelWidth={labelWidth} ctx={ctx} historicalYears={historicalYears} />
          )}
          <QuarterHeaderRow labelWidth={labelWidth} ctx={ctx} />
        </thead>
        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  );
}
